import Vue from 'vue'
import VueCountdown from '@xkeshi/vue-countdown'

Vue.component('countdown', VueCountdown)



// WEBPACK FOOTER //
// ./src/initializers/vue-countdown.js